/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
// eslint-disable-next-line unicorn/no-unsafe-regex
export const POSITIVE_NUMBER_REGEX = /^([0-9,.]*)$/;
